module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 70300.3b81580e.png";